export default __webpack_public_path__ + "static/media/forexImg.03f70eed.webp";